<template>
  <div class="refund-order-list" v-loading="loading">
    <template v-if="orderList.length">
      <table class="refund-order">
        <tr>
          <th class="info">订单详情</th>
          <th>金额</th>
          <th>收货人</th>
          <th>操作</th>
        </tr>
        <template v-for="order in orderList">
          <tr :key="order.orderNumber"><td colspan="6"></td></tr>
          <tr class="refund-order-header">
            <td colspan="6">
              <span class="mr-10">下单时间：{{ order.createTime }}</span>
              <span class="mr-10">订单编号：{{ order.orderNumber }}</span>
              <span class="mr-10">商家：{{ order.merchantName }}</span>
            </td>
          </tr>
          <tr class="refund-order-content">
            <td>
              <div class="good clearfix" v-for="good in order.orderCommodityList" :key="good.bxysid">
                <el-image class="good-cover fl" :src="good.specificationImg || good.commodityImage" fit="contain"></el-image>
                <div @click="$tools.showGoodInBlank(good.commodityId)" class="good-title u-line-two">{{ good.commodityName }}</div>
                <div class="good-sku">{{ good.attributes || '默认规格' }}</div>
              </div>
            </td>
            <td>￥{{order.amount | decimal}}</td>
            <td>{{ order.recipient }}</td>
            <td>
              <router-link tag="div" :to="`/myOrderDetail?orderNumber=${order.orderNumber}&bxmId=${order.bxmId}`"><el-link type="info">订单详情</el-link></router-link>
              <router-link tag="div" :to="`/orderAppraisal?orderNumber=${order.orderNumber}&bxmId=${order.bxmId}`" v-if="order.evaluationFlag === 'N'"><el-link type="warning">立即评价</el-link></router-link>
            </td>
          </tr>
        </template>
      </table>
      <Pagination v-bind:child-msg="{ total, pageSize, currentPage: pageNum }" @callFather="handlePageChange"></Pagination>
    </template>
    <template v-else>
      <empty>暂无相关订单</empty>
    </template>
  </div>
</template>

<script type="text/ecmascript-6">
import Pagination from '@/components/Pagination';
import {showorderList} from '../api/xunyou';
export default {
  name: 'goodsAppraisalOrder',
  data() {
    return {
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      orderList: []
    }
  },
  props: {evaluationFlag: String},
  components: {
    Pagination
  },
  created() {
    this.getOrderList();
  },
  methods: {
    // 翻页
    handlePageChange (val) {
      this.pageSize = val.pageSize;
      this.pageNum = val.currentPage;
      this.getOrderList();
    },
    getOrderList () {
      const params = {
        evaluationFlag: this.evaluationFlag, // Y/N
        muid: this.$store.getters.userId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.loading = true
      showorderList(params).then(res => {
        this.loading = false;
        console.log('评价订单：', res);
        if (res.code === 0) {
          this.orderList = res.rows;
          this.total = res.total;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('查询失败，请稍后再试！')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.mr-10{
  margin-right: 10px;
}
.red{
  color: var(--main-theme-color) !important;
}
.grey{
  color: #888888 !important;
}
.refund-order{
  margin-top: 10px;
  width: 100%;
  .refund-order-header{
    padding: 0 20px;
    background: #EAF8FF;
    font-size: 12px;
    border: 1px solid #91CFFF;
    color: #3c3c3c;
  }
  .refund-order-content{
    border: 1px solid #eeeeee;
  }
  th{
    background-color: #e9e9e9;
    padding: 10px;
    text-align: left;
  }
  td{
    padding: 10px;
  }
  .info{
    width: 350px;
  }
  .good-cover{
    width: 70px;
    height: 70px;
    border: 1px solid #F5F5F5;
    border-radius: 3px;
    margin-right: 10px;
  }
  .good-title{
    font-size: 14px;
    line-height: 1.3;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover{
      text-decoration: underline;
      color: #ff6700;
    }
  }
  .amount{
    color: var(--main-theme-color);
  }
  .state{
    color: #0c80dc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goodsAppraisalOrder.vue